import { SubmitButton } from "../../../styles/styled";
import { FormCardH2 } from "../index";
import styled from "@emotion/styled";

const WaitlistCopy = styled.p `
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  margin: 0 0 24px;
`

const BusinessWaitlist = () => {

  const contactSales = () => {
    window.location.assign('/contact-sales');
  };

  return (
    <>
      <FormCardH2>Business Account Waitlist</FormCardH2>
      <WaitlistCopy>
        Due to soaring demand for our crypto payment solution, we've temporarily
        paused signups for new accounts. Join the waitlist and enter the queue
        to be notified when we're ready to accept new registrations.
      </WaitlistCopy>
      <SubmitButton secondary aria-label="Join the Waitlist" onClick={contactSales}>Join the Waitlist</SubmitButton>
    </>
  );
}

export default BusinessWaitlist;
